// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"wq-z","imageAndVideoCount":"xq-z","imageAndVideoContainer":"yq-z","viewAllReviews":"zq-z"};